export default "__VITE_ASSET__fvJp2Qku__"